import Map from "./icons/map.svg";
import ThumbsUp from "./icons/thumbs.up.svg";
import Notification from "./icons/notification.on.svg";
import Star from "./icons/star.svg";
import styles from "./quiz-results.module.css";

type Result = {
  image: string;
  title: string;
  subtitle: string;
  highlight: string;
  doingRight?: string;
  nextSteps: string;
  immediateActions?: string;
};

const QuizResults = ({ result }: { result: Result }) => {
  let highlight = result.highlight;
  let proTip = false;

  if (highlight.startsWith("Pro Tip: ")) {
    highlight = highlight.replace("Pro Tip: ", "");
    proTip = true;
  }

  return (
    <div>
      <div className={styles.container}>
        <div>
          <img src={result.image} alt="Illustration" className={styles.image} />
        </div>

        <div className={styles.textContainer}>
          <div className={styles.spaceY2}>
            <h2 className={styles.title}>{result.title}</h2>
            <p className={styles.subtitle}>{result.subtitle}</p>
          </div>
          <div className={styles.section}>
            {result.doingRight && (
              <div className={styles.sectionItem}>
                <h3 className={styles.sectionTitle}>
                  <img
                    src={ThumbsUp}
                    className={styles.imageIcon}
                    alt="Thumbs up"
                  />{" "}
                  What you&rsquo;re doing right
                </h3>
                <p className={styles.sectionText}>{result.doingRight}</p>
              </div>
            )}
            <div className={styles.sectionItem}>
              <h3 className={styles.sectionTitle}>
                <img src={Map} className={styles.imageIcon} alt="Map" /> Next
                steps to consider
              </h3>
              <p className={styles.sectionText}>{result.nextSteps}</p>
            </div>
            {result.immediateActions && (
              <div className={styles.sectionItem}>
                <h3 className={styles.sectionTitle}>
                  <img
                    src={Notification}
                    className={styles.imageIcon}
                    alt="Notification"
                  />{" "}
                  Immediate actions
                </h3>
                <p className={styles.sectionText}>{result.immediateActions}</p>
              </div>
            )}
          </div>
          <div className={styles.proTipContainer}>
            {proTip && (
              <div className={styles.proTip}>
                <img src={Star} alt="Star" className={styles.imageIcon} />
                <div className={styles.proTipText}>Pro Tip</div>
              </div>
            )}
            <p className={styles.highlight}>{highlight}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizResults;
